
import { NgbModal,NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from "@angular/core";
import { UserModel, UserFilterModel, UserService } from "@bt/core";
import * as $ from 'jquery';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from 'angular-notifier';
import { ValidationModel } from '@bt/core/models/validation.model';
//import 'sweetalert2/src/sweetalert2.scss';


import {  Input } from '@angular/core';
import { ChangePasswordModal } from '@bt/core/models/changePasswordModal.model';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'change-password-modal',
  templateUrl:"change-password.modal.html",
  styleUrls: ["./change-password.modal.scss"]
})
export class ChangePasswordModalContent {
  @Input() user : UserModel;
  public changePasswordModal : ChangePasswordModal;
  public changePasswordForm: FormGroup;
  public isSubmitted: boolean = false;
  public min6symbol:boolean = false;
  public Status: boolean = false; 
  private notifier: NotifierService;
  public canShowUserName: boolean;
  public passwordModel:any;
  public passwordConfModel:any;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal,
        notifierService: NotifierService) {
    this.notifier = notifierService;
    this.changePasswordModal = new ChangePasswordModal();
  }

  public ngOnInit() {
    this.changePasswordForm = this.fb.group({
        newPassword: new FormControl("", Validators.required),
        newPasswordConfirmation: new FormControl("", [Validators.required]),
        needSendToEmail: new FormControl(true)
    });

    if(!!this.user.lastName && !!this.user.firstName && this.user.lastName.length > 0 && this.user.firstName.length > 0)
      this.canShowUserName = true;
    else
      this.canShowUserName = false;
  }
  get newPassword() { return this.changePasswordForm.get('newPassword'); }
  get newPasswordConfirmation() { return this.changePasswordForm.get('newPasswordConfirmation'); }
  get needSendToEmail() { return this.changePasswordForm.get('needSendToEmail'); }

  public isPasswordsEqual(): boolean {
    if(this.newPassword.value != this.newPasswordConfirmation.value)
        return false;
    return true;
}
  public changePassword() {

     this.Status = true; 

     this.isSubmitted = true;

     var validResult = this.Validate();
       var validConfirmResult = this.ValidatePassword();

       if(!validResult.isValid){
          this.notifier.notify('error',validResult.error);
       }

       else if(!validConfirmResult.isValid){
        this.notifier.notify('error',validConfirmResult.error);
     }
     
     else {
        this.changePasswordModal.newPassword = this.newPassword.value;
        this.changePasswordModal.newPasswordConf = this.newPasswordConfirmation.value;
        this.changePasswordModal.needSendToEmail = this.needSendToEmail.value;
        this.changePasswordModal.needChange = true;
        this.activeModal.close(this.changePasswordModal);
     }
 }

 public Validate(){

  var test = '' + (<any>this.newPassword)._pendingValue;
  var length = test.length;    

  var result = new ValidationModel();
  result.isValid = true;

  if (this.newPassword.errors && this.newPassword.errors.required && (this.newPassword.dirty || this.isSubmitted)){
      result.isValid = false;
      result.error = "Необходимо ввести пароль";
  }

  else if (length < 6  ) {
      result.isValid = false;
      result.error = "Длина пароля должна превышать 5 символов";
  }  

  return result;
}

public ValidatePassword(){
  var result = new ValidationModel();
  result.isValid = true;

  var test1 = '' + (<any>this.newPasswordConfirmation)._pendingValue;
  var length1 = test1.length;

 
  if (this.newPasswordConfirmation.errors && this.newPasswordConfirmation.errors.required  && (this.newPasswordConfirmation.dirty || this.isSubmitted)){
      result.isValid = false;
      result.error = "Подтверждение пароля обязательно для заполнения";
  }

  else if(!this.isPasswordsEqual() && (this.newPasswordConfirmation.dirty || this.isSubmitted)){
      result.isValid = false;
      result.error = "Подтверждение не соответствует введенному паролю";
  }

  else if (length1 < 6  ) {
      result.isValid = false;
      result.error = "Длина пароля должна превышать 5 символов";
  }     

  return result;
}


  public cancel() {
    this.activeModal.close(this.changePasswordModal);
  }
}


// WEBPACK FOOTER //
// ./src/app/admin/all-users/change-password-modal/change-password.modal.ts